import ReactEDSWrapper from '../../../utils/react-eds-wrapper';
import { Button, Input, Table, Row, Cell, Pagination } from '@dsi/react-eds';
import styles from './ProductNumberTable.module.css';

interface ProductNumberTableProps {
  productNumbers: { sw_product_no: string; name: string }[];
  page: number;
  pageSize: string;
  numPages: number;
  filterNumber: string;
  filterName: string;
  sortAttr: 'sw_product_no' | 'name' | undefined;
  sortOrder: 'asc' | 'desc' | undefined;
  onEdit: (idx: number) => void;
  onDelete: (idx: number) => void;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: string) => void;
  onSort: (order: 'asc' | 'desc', attr: 'sw_product_no' | 'name') => void;
  onFilterNumber: (val: string) => void;
  onFilterLine: (val: string) => void;
}

const ProductNumberTable: React.FC<ProductNumberTableProps> = ({
  productNumbers,
  page,
  pageSize,
  numPages,
  filterNumber,
  filterName,
  sortAttr,
  sortOrder,
  onEdit,
  onDelete,
  onPageChange,
  onPageSizeChange,
  onSort,
  onFilterNumber,
  onFilterLine,
}) => {
  const columns = [
    {
      title: 'Product Number',
      attribute: 'sw_product_no',
      sortable: true,
      width: '50%',
      sortOrder: sortAttr === 'sw_product_no' ? sortOrder : undefined,
    },
    {
      title: 'Description',
      attribute: 'name',
      sortable: true,
      sortOrder: sortAttr === 'name' ? sortOrder : undefined,
    },
    { title: '', attribute: 'actions' },
  ];

  return (
    <div className={styles.productNumberListContainer}>
      <div className={styles.settingsTitle}>Product Number List</div>
      <div className={styles.productNumberListInfo}>
        {productNumbers.length > 0 ? `${(page - 1) * parseInt(pageSize, 10) + 1} - ${Math.min(page * parseInt(pageSize, 10), productNumbers.length)} of ${productNumbers.length} items` : null}
      </div>
      <ReactEDSWrapper
        component={Table}
        columns={columns}
        filters={
          <ReactEDSWrapper component={Row}>
            <ReactEDSWrapper component={Cell}>
              <ReactEDSWrapper
                component={Input}
                className={styles.searchField}
                placeholder="Filter"
                type="search"
                value={filterNumber}
                onChange={e => {
                  const value = (e.target as HTMLInputElement).value;
                  onFilterNumber(value);
                }}
              />
            </ReactEDSWrapper>
            <ReactEDSWrapper component={Cell}>
              <ReactEDSWrapper
                component={Input}
                className={styles.searchField}
                placeholder="Filter"
                type="search"
                value={filterName}
                onChange={e => {
                  const value = (e.target as HTMLInputElement).value;
                  onFilterLine(value);
                }}
              />
            </ReactEDSWrapper>
            <ReactEDSWrapper component={Cell} />
          </ReactEDSWrapper>
        }
        showFilters
        sortable
        onSort={(order: 'asc' | 'desc', attr: 'sw_product_no' | 'name') => {
          onSort(order, attr);
        }}
      >
        {productNumbers.map((product, idx) => (
          <ReactEDSWrapper component={Row} key={idx}>
            <ReactEDSWrapper component={Cell}>{product.sw_product_no}</ReactEDSWrapper>
            <ReactEDSWrapper component={Cell}>{product.name}</ReactEDSWrapper>
            <ReactEDSWrapper component={Cell} className={styles.actionsCell}>
              <ReactEDSWrapper
                component={Button}
                className={`btn icon-btn ${styles.iconBtn}`}
                aria-label="Edit"
                onClick={() => onEdit(idx)}
              >
                <i className="icon icon-edit"></i>
              </ReactEDSWrapper>
              <ReactEDSWrapper
                component={Button}
                className={`btn icon-btn ${styles.iconBtn}`}
                aria-label="Delete"
                onClick={() => onDelete(idx)}
              >
                <i className="icon icon-trashcan"></i>
              </ReactEDSWrapper>
            </ReactEDSWrapper>
          </ReactEDSWrapper>
        ))}
      </ReactEDSWrapper>
      <ReactEDSWrapper
        component={Pagination}
        numPages={numPages}
        selectedPage={page}
        onPaginationChangePage={onPageChange}
        optionsList={[
          { value: '10', label: '10', active: pageSize === '10' },
          { value: '20', label: '20', active: pageSize === '20' },
          { value: '30', label: '30', active: pageSize === '30' },
        ]}
        onPaginationChangeSelect={onPageSizeChange}
        withActions
      />
    </div>
  );
};

export default ProductNumberTable;
